import * as React from 'react';

const localState = localStorage.getItem("user_state") !== null ? JSON.parse(localStorage.getItem("user_state")!) : null;

let reducer = (state: UserState, newState: UserState) => {
    if (newState === null) {
        localStorage.removeItem("user_state");
        return initialState;
    }

    return { ...state, ...newState };
};

export interface UserState {
    locale: string;
    userIdentifier: string | null;
    userId: number | null;
}

const initialState: UserState = {
    locale: /*'es-mx'*/'en-us',
    userIdentifier: null,
    userId: null,
};

export const UserStateContext = React.createContext<{state: UserState; setState: React.Dispatch<any>;}>({state: initialState, setState: () => null});

const UserStateContextProvider = (props: { children?: React.ReactNode }) => {
    const [userState, setUserState] = React.useReducer(reducer, localState || initialState);
    
    React.useEffect(() => {
        localStorage.setItem("user_state", JSON.stringify(userState));
    }, [userState]);

    return (
        //@ts-ignore
        <UserStateContext.Provider value={{ state: userState, setState: setUserState }}>
            {props.children}
        </UserStateContext.Provider>
    );
}

export default UserStateContextProvider;